export default "__VITE_ASSET__Bf61g_e3__"